import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
var PrivateRoute = function PrivateRoute(_ref) {
  var element = _ref.element;
  var isLoggedIn = useSelector(function (s) {
    return s.app.isLoggedIn;
  });
  if (!isLoggedIn) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/",
      replace: true
    });
  }
  return element;
};
export default PrivateRoute;